/**
 * Enum para representar os status de boletas de renda variável
 * Cada valor numérico corresponde ao status_id no banco de dados
 */
export enum StatusBoletaRendaVariavelEnum {
    // Renda Variável (RV)
    BOLETA_MRV = 1,
    PRIMEIRA_OPERACAO = 2,
    ENVIADA = 3,
    RECUSA_DA_ORDEM = 4,
    DESACORDO_PERFIL = 5,
    DESABILITADO_BOVESPA = 6,
    CADASTRO_PENDENTE = 7,
    SALDO_INDISPONIVEL = 8,
    PUSH_DESABILITADO = 9,
    OPERACAO_EFETIVADA = 10,
    ORDEM_EXPIRADA = 11,
    EFETIVADA_PARCIALMENTE = 12,
    PENDENTE_APROVACAO_MESA = 13,
    PENDENTE_APROVACAO_ASSESSOR = 14,
    ACAO_COMERCIAL = 21,

    // COE (CO)
    BOLETA_COE = 15,
    COE_ENVIADO_CLIENTE = 17,
    COE_REGISTRADO = 18,
    COE_EFETIVADO_DEBITADO = 19,
    COE_SALDO_INSUFICIENTE = 20,
    COE_RESGATADO_LIQUIDADO = 39,

    // Renda Fixa (RF)
    BOLETA_RF = 16,
    RF_EFETIVADO_DEBITADO = 37,
    RF_ENVIADO_CLIENTE = 38,

    // Patrimônio/Apólice (PA)
    CLIENTE_POTENCIAL = 22,
    REUNIAO_1_AGENDADA = 23,
    REUNIAO_1_EFETIVADA_DADOS = 24,
    REUNIAO_2_AGENDADA = 25,
    REUNIAO_2_EFETIVADA_PROPOSTA = 26,
    PROPOSTA_ACEITA_EM_TRANSITO = 27,
    APOLICE_COM_PENDENCIA = 28,
    APOLICE_EFETIVADA_FINAL = 29,
    APOLICE_RECUSADA = 31,

    // Previdência (PE)
    PREV_EM_OUTRA_INSTITUICAO = 32,
    PROPOSTA_PORTABILIDADE = 33,
    PORTABILIDADE_EM_TRANSITO = 34,
    PORTABILIDADE_EFETIVADA = 35,
    PORTABILIDADE_RECUSADA = 36,

    // Fundos (FU)
    FU_EFETIVADO_DEBITADO = 40,
}
